import axios from "axios";
import { apiURL } from './api.js';

// Function to get all users
// export const getAllUsers = async () => {
//     try {
//         const response = await axios.get(`${apiURL}/users`);

//         if (!response.ok) {
//             throw new Error('Failed to fetch users');
//         }
//         const users = await response.data;
//         return users;
//     } catch (error) {
//         console.error('Error fetching users:', error);
//         throw error;
//     }
// };

// Function to get user by ID
// export const getUserById = async (id) => {
//     try {
//         const response = await axios.get(`${apiURL}/users?id=${id}`);

//         if (!response.ok) {
//             throw new Error('Failed to fetch user');
//         }
//         const user = await response.data;
//         return user;
//     } catch (error) {
//         console.error('Error fetching user:', error);
//         throw error;
//     }
// };

// Function to get user by Email
// export const getUserByEmail = async (email) => {
//     try {
//         const response = await axios.get(`${apiURL}/users?email=${email}`);
        
//         if (!response.ok) {
//             throw new Error('Failed to fetch user');
//         }
//         const user = await response.data;
//         return user;
//     } catch (error) {
//         console.error('Error fetching user:', error);
//         throw error;
//     }
// };

// Function to Login - calls Laravel API via proxy
export const login = async (email, password) => {
    try {
        const payload = {
            email: email,
            password: password,
            device_name: 'Web Browser',
            device_id: null
        };
        
        const response = await axios.post(`${apiURL}/login`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        
        if(response.status === 200 || response.status === 201) {
            // Laravel returns { token, user }
            return response.data;
        } else {
            throw new Error('Failed to login');
        }
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

// Function to Add User - calls Laravel API via proxy
export const addUsers = async (first_name, last_name, email, dialCode, phone_number, password, news_and_offers, accept_general_condition) => {
    try {
        const payload = {
            first_name: first_name,
            last_name: last_name,
            email: email,
            password: password,
            password_confirmation: password,
            regional_code: dialCode,
            phone_number: phone_number,
            news_and_offers: news_and_offers || false,
            follow_up_my_kids: false,
            follow_kids_by_phone: false,
            accept_general_condition: accept_general_condition,
            device_name: 'Web Browser',
            device_id: null
        };
        console.log(payload);
        const response = await axios.post(`${apiURL}/register`, payload, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
        });
        console.log("Response Status: ", response.status);
        console.log(response.data);
        
        if(response.status === 200 || response.status === 201) {
            // Laravel returns { message, user, token }
            // Return the user object with id for compatibility
            const result = {
                id: response.data.user?.id,
                ...response.data.user,
                token: response.data.token
            };
            return result;
        } else {
            throw new Error('Failed to add user');
        }
    } catch (error) {
        console.error('Error adding user:', error);
        throw error;
    }
};

// Function to send verification email
// export const sendVerificationEmail = async (email, userId) => {
//     try {
//         const payload = {
//             email: email,
//             userId: userId
//         };
        
//         const response = await axios.post(`${apiURL}/sendVerificationEmail`, payload, {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
        
//         if(response.status === 200 || response.status === 201) {
//             return response.data;
//         } else {
//             throw new Error('Failed to send verification email');
//         }
//     } catch (error) {
//         console.error('Error sending verification email:', error);
//         throw error;
//     }
// };

// Function to resend verification email
export const resendVerificationEmail = async (email, userId) => {
    try {
        const payload = {
            email: email,
            userId: userId
        };
        
        const response = await axios.post(`${apiURL}/resendVerificationEmail`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if(response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error('Failed to resend verification email');
        }
    } catch (error) {
        console.error('Error resending verification email:', error);
        throw error;
    }
};

// Function to verify email with token
export const verifyEmail = async (email, token) => {
    try {
        const payload = {
            email: email,
            token: token
        };
        
        const response = await axios.post(`${apiURL}/verifyEmail`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if(response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error('Failed to verify email');
        }
    } catch (error) {
        console.error('Error verifying email:', error);
        throw error;
    }
};

// Function to get current user profile
export const getUserProfile = async () => {
    try {
        const token = localStorage.getItem('authToken');

        if (!token) {
            throw new Error('Authentication token is required');
        }

        const response = await axios.get(`${apiURL}/user`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Failed to fetch user profile');
        }
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};

// Function to update user profile
export const updateUserProfile = async (firstName, lastName, phoneNumber) => {
    try {
        const token = localStorage.getItem('authToken');

        if (!token) {
            throw new Error('Authentication token is required');
        }

        const response = await axios.put(`${apiURL}/user/profile`, {
            first_name: firstName,
            last_name: lastName,
            phone_number: phoneNumber,
        }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Failed to update profile');
        }
    } catch (error) {
        console.error('Error updating profile:', error);
        throw error;
    }
};

// Function to change user password
export const changePassword = async (userId, oldPassword, newPassword) => {
    try {
        const token = localStorage.getItem('authToken');

        if (!token) {
            throw new Error('Authentication token is required');
        }

        const response = await axios.post(`${apiURL}/change-password`, {
            user_id: userId,
            old_password: oldPassword,
            new_password: newPassword,
        }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Failed to change password');
        }
    } catch (error) {
        console.error('Error changing password:', error);
        throw error;
    }
};